import { render } from "./SensoresSC.vue?vue&type=template&id=4721e7a2&scoped=true"
import script from "./SensoresSC.vue?vue&type=script&lang=js"
export * from "./SensoresSC.vue?vue&type=script&lang=js"

import "./SensoresSC.vue?vue&type=style&index=0&id=4721e7a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4721e7a2"]])

export default __exports__